const root = document.querySelector('#vm-builder');
if (!root) throw new Error('VoiceWave customizer root not found');

const $ = (selector) => root.querySelector(selector);
const $$ = (selector) => [...root.querySelectorAll(selector)];
const canvas = $('[data-waveform]');
const ctx = canvas.getContext('2d');
const audio = $('[data-audio]');
const fileInput = $('#vm-media-file');
const wallInput = $('#vm-wall-file');
const dropZone = $('[data-drop-zone]');
const productionProducts = {
  canvas: { label: 'Canvas', orientation: 'square', size: '8 × 8 in', frame: 'none', mat: 'none', price: 89.99, compare: 109.99 },
  'framed-print': { label: 'Wooden Framed Poster', orientation: 'portrait', size: '5 × 7 in', frame: 'white', mat: 'none', price: 69.99, compare: 89.99 },
  'aluminum-print': { label: 'Aluminum Print', orientation: 'square', size: '8 × 8 in', frame: 'none', mat: 'none', price: 119.99, compare: 149.99 }
};
const frameOptionNames = { black: 'Black frame', white: 'White frame', oak: 'Natural oak', walnut: 'Walnut frame', none: 'Unframed' };
let catalogVariants = {};
try { catalogVariants = JSON.parse($('[data-variant-map]')?.textContent || '{}'); } catch (_) { catalogVariants = {}; }
let waveform = Array.from({ length: 120 }, (_, i) => 0.15 + Math.abs(Math.sin(i * .37)) * .42);
let uploadedFile = null;
let sampleMode = false;
let recorder = null;
let chunks = [];
let product3D = null;
let wallPhotoUrl = null;
let memoryId = null;
let memoryReady = false;
let previewFrame = 0;
const secureUploadEnabled = root.dataset.secureUpload === 'true';

function state() {
  return {
    product: $('input[name="product"]:checked')?.value || 'canvas', title: $('[data-title]').value.trim(), kicker: $('[data-kicker]').value.trim(), date: $('[data-date]').value.trim(),
    waveColor: $('[data-color]').value, background: $('[data-bg]').value, waveform,
    orientation: $('[data-orientation]').value, size: $('[data-size]').value,
    frame: $('[data-frame]').value, mat: $('[data-mat]').value,
    fontStyle: $('[data-font-style]:checked')?.value || 'editorial'
  };
}

function hexToRgb(hex) {
  const value = String(hex || '').replace('#', '');
  if (!/^[0-9a-f]{6}$/i.test(value)) return { r: 0, g: 0, b: 0 };
  return { r: parseInt(value.slice(0, 2), 16), g: parseInt(value.slice(2, 4), 16), b: parseInt(value.slice(4, 6), 16) };
}

function relativeLuminance(hex) {
  const { r, g, b } = hexToRgb(hex);
  const channels = [r, g, b].map(value => {
    const srgb = value / 255;
    return srgb <= .04045 ? srgb / 12.92 : Math.pow((srgb + .055) / 1.055, 2.4);
  });
  return channels[0] * .2126 + channels[1] * .7152 + channels[2] * .0722;
}

function contrastRatio(a, b) {
  const first = relativeLuminance(a), second = relativeLuminance(b);
  return (Math.max(first, second) + .05) / (Math.min(first, second) + .05);
}

function artworkPalette(background, requestedWave) {
  const darkText = '#241f1b', darkMuted = '#615852';
  const lightText = '#f8f2e8', lightMuted = '#d8cec2';
  const warmChoices = [
    { text: lightText, muted: lightMuted, ratio: contrastRatio(lightText, background) },
    { text: darkText, muted: darkMuted, ratio: contrastRatio(darkText, background) }
  ].sort((a, b) => b.ratio - a.ratio);
  const fallbackChoices = [
    { text: '#ffffff', muted: '#ffffff', ratio: contrastRatio('#ffffff', background) },
    { text: '#000000', muted: '#000000', ratio: contrastRatio('#000000', background) }
  ].sort((a, b) => b.ratio - a.ratio);
  const chosenText = warmChoices[0].ratio >= 4.5 ? warmChoices[0] : fallbackChoices[0];
  const { text, muted } = chosenText;
  const candidates = [requestedWave, '#b86f50', '#d7ad72', '#72a9d6', '#f0dfc5', '#173f3a', '#2b2420'];
  const requestedRatio = contrastRatio(requestedWave, background);
  const wave = requestedRatio >= 3 ? requestedWave : candidates.map(color => ({ color, ratio: contrastRatio(color, background) })).sort((a, b) => b.ratio - a.ratio)[0]?.color || text;
  return { text, muted, wave, adjusted: wave.toLowerCase() !== requestedWave.toLowerCase(), textRatio: contrastRatio(text, background), waveRatio: contrastRatio(wave, background) };
}

function drawWave(target = ctx, width = canvas.width, height = canvas.height) {
  target.clearRect(0, 0, width, height);
  target.fillStyle = artworkPalette($('[data-bg]').value, $('[data-color]').value).wave;
  const middle = height / 2;
  const gap = Math.max(2, width / 450);
  const barWidth = Math.max(2, width / waveform.length - gap);
  waveform.forEach((value, index) => {
    const h = Math.max(5, value * height * .82);
    target.fillRect(index * (barWidth + gap), middle - h / 2, barWidth, h);
  });
}

function renderArtwork() {
  const art = document.createElement('canvas');
  const s = state();
  const dimensions = s.orientation === 'portrait' ? [900, 1125] : s.orientation === 'square' ? [1000, 1000] : [1125, 900];
  art.width = dimensions[0]; art.height = dimensions[1];
  const c = art.getContext('2d');
  const palette = artworkPalette(s.background, s.waveColor);
  c.fillStyle = s.background; c.fillRect(0, 0, art.width, art.height);
  c.textAlign = 'center'; c.fillStyle = palette.muted;
  c.font = `700 ${Math.round(art.width * .022)}px Arial`; c.fillText(s.kicker || 'OPTIONAL HEADING', art.width / 2, art.height * .16);
  c.fillStyle = palette.wave;
  const waveTop = art.height * .28, waveHeight = art.height * .31, gap = Math.max(3, art.width / 330), bw = (art.width * .72) / waveform.length - gap;
  waveform.forEach((value, i) => { const h = Math.max(6, value * waveHeight); c.fillRect(art.width * .14 + i * (bw + gap), waveTop + (waveHeight - h) / 2, bw, h); });
  const fontFamilies = { editorial: 'Georgia', modern: 'Arial', handwritten: '"Segoe Print"' };
  const fontWeights = { editorial: 700, modern: 600, handwritten: 600 };
  c.fillStyle = palette.text; c.font = `${fontWeights[s.fontStyle]} ${Math.round(art.width * .052)}px ${fontFamilies[s.fontStyle]}`; c.fillText((s.title || 'YOUR MESSAGE HERE').slice(0, 38), art.width / 2, art.height * .72);
  c.fillStyle = palette.muted; c.font = `600 ${Math.round(art.width * .021)}px Arial`; c.fillText(s.date || 'DATE · NAME · PLACE', art.width / 2, art.height * .79);
  return art;
}

function syncPreview() {
  const s = state();
  const palette = artworkPalette(s.background, s.waveColor);
  $('[data-preview-title]').textContent = s.title || 'YOUR MESSAGE HERE';
  $('[data-preview-kicker]').textContent = s.kicker || 'OPTIONAL HEADING';
  $('[data-preview-date]').textContent = s.date || 'DATE · NAME · PLACE';
  $('[data-preview-title]').dataset.fontStyle = s.fontStyle;
  $('[data-art-preview]').style.background = s.background;
  $('[data-preview-title]').style.color = palette.text;
  $('[data-preview-kicker]').style.color = palette.muted;
  $('[data-preview-date]').style.color = palette.muted;
  const contrastNote = $('[data-contrast-note]');
  if (contrastNote) {
    contrastNote.textContent = palette.adjusted ? `Wave color optimized for visibility (${palette.waveRatio.toFixed(1)}:1 contrast).` : `Readable combination: text ${palette.textRatio.toFixed(1)}:1 · wave ${palette.waveRatio.toFixed(1)}:1.`;
    contrastNote.classList.toggle('is-adjusted', palette.adjusted);
  }
  $('[data-preview-tag]').textContent = !uploadedFile ? (sampleMode ? 'Exploration preview' : 'Sample preview') : (s.title || s.kicker || s.date ? 'Your live preview' : 'Your waveform · sample copy');
  $('[data-art-preview]').dataset.layout = s.orientation;
  drawWave();
  const renderedArtwork = renderArtwork();
  const url = renderedArtwork.toDataURL('image/webp', .86);
  $('[data-held-art]').style.backgroundImage = `url("${url}")`;
  $('[data-held-art]').className = `vm-product-art orientation-${s.orientation} frame-${s.frame}`;
  $('[data-edge-face]').style.backgroundImage = `url("${url}")`;
  $('[data-edge-object]').className = `edge-object orientation-${s.orientation} frame-${s.frame}`;
  $('[data-room-art]').style.backgroundImage = `url("${url}")`;
  $('[data-room-art]').className = `room-art orientation-${s.orientation} frame-${s.frame}`;
  $('[data-review-file]').textContent = uploadedFile?.name || (sampleMode ? 'Sample soundwave — replace before order' : '—');
  $('[data-sample-warning]').hidden = !sampleMode;
  const productContract = productionProducts[s.product] || productionProducts.canvas;
  $('[data-review-product]').textContent = productContract.label;
  $('[data-review-finish]').textContent = `${s.size} · ${s.frame === 'none' ? 'Unframed' : `${s.frame} frame`}`;
  $('[data-review-message]').textContent = s.title || '—';
  const catalogVariant = catalogVariants[`${s.product}|${s.size}|${frameOptionNames[s.frame]}`] || catalogVariants[`${s.size}|${frameOptionNames[s.frame]}`];
  const total = Number(catalogVariant?.price ?? productContract.price);
  const compare = Number(catalogVariant?.compare ?? productContract.compare);
  $$('[data-total]').forEach(node => node.textContent = `$${total.toFixed(2)}`);
  $$('[data-compare-price]').forEach(node => node.textContent = `$${compare.toFixed(2)}`);
  $$('[data-save]').forEach(node => node.textContent = `Save $${Math.round(compare - total)}`);
  if (product3D) product3D.update(s, renderedArtwork);
}

function schedulePreview() {
  if (previewFrame) return;
  previewFrame = requestAnimationFrame(() => {
    previewFrame = 0;
    syncPreview();
  });
}

function setStep(number) {
  root.classList.toggle('is-editing', number > 1);
  root.dataset.currentStep = String(number);
  $$('[data-step]').forEach(node => { const active = Number(node.dataset.step) === number; node.hidden = !active; node.classList.toggle('active', active); });
  $$('[data-step-nav]').forEach(node => {
    const active = Number(node.dataset.stepNav) === number;
    node.classList.toggle('active', active);
    if (active) node.setAttribute('aria-current', 'step');
    else node.removeAttribute('aria-current');
  });
  if (number === 4) { syncPreview(); $('[data-view="product"]').click(); }
  if (window.innerWidth < 900) $('.vm-progress').scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function unlockSteps() {
  $$('[data-step-nav]').forEach(node => node.disabled = false);
  $('[data-next="2"]').disabled = false;
}

async function loadMedia(file) {
  if (!file) return;
  const orderError = $('[data-order-error]');
  orderError.hidden = true;
  orderError.textContent = '';
  sampleMode = false;
  uploadedFile = file;
  memoryId = null;
  memoryReady = false;
  $('[data-file-name]').textContent = `${file.name} · creating your soundwave…`;
  $('[data-preview-help]').textContent = 'Creating your soundwave preview…';
  try {
    const buffer = await file.arrayBuffer();
    const context = new (window.AudioContext || window.webkitAudioContext)();
    const decoded = await context.decodeAudioData(buffer.slice(0));
    const channel = decoded.getChannelData(0), points = 120, block = Math.max(1, Math.floor(channel.length / points));
    waveform = Array.from({ length: points }, (_, index) => { let peak = 0; for (let i = index * block; i < Math.min((index + 1) * block, channel.length); i += 12) peak = Math.max(peak, Math.abs(channel[i])); return Math.max(.03, peak); });
    await context.close();
  } catch (_) {
    waveform = Array.from({ length: 120 }, (_, i) => .12 + Math.abs(Math.sin(i * .29)) * .52);
  }
  audio.src = URL.createObjectURL(file);
  $('[data-audio-preview]').hidden = false;
  $('[data-file-name]').textContent = `${file.name} · ready`;
  $('[data-preview-tag]').textContent = 'Your live preview';
  $('[data-preview-help]').textContent = 'Your recording is ready. Play it back or continue to personalize the design.';
  if (secureUploadEnabled) {
    const status = $('[data-secure-status]');
    status.textContent = 'Securing your private memory…';
    try {
      const response = await fetch('/apps/voicewave/upload', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ filename: file.name, contentType: file.type, byteSize: file.size })
      });
      const payload = await response.json();
      if (!response.ok || !payload.uploadUrl || !payload.memoryId) throw new Error(payload.error || 'Secure upload could not start.');
      const upload = await fetch(payload.uploadUrl, { method: 'PUT', headers: { 'Content-Type': file.type }, body: file });
      if (!upload.ok) throw new Error('Secure upload did not finish.');
      memoryId = payload.memoryId;
      status.textContent = 'Private memory secured.';
    } catch (error) {
      status.textContent = error.message || 'Secure upload failed. Please try again.';
    }
  } else {
    $('[data-secure-status]').textContent = 'Preview mode — production upload is not enabled yet.';
  }
  unlockSteps(); syncPreview();
}

fileInput.addEventListener('change', event => loadMedia(event.target.files[0]));
['dragenter', 'dragover'].forEach(type => dropZone.addEventListener(type, event => { event.preventDefault(); dropZone.classList.add('dragging'); }));
['dragleave', 'drop'].forEach(type => dropZone.addEventListener(type, event => { event.preventDefault(); dropZone.classList.remove('dragging'); }));
dropZone.addEventListener('drop', event => loadMedia(event.dataTransfer.files[0]));

$('[data-record]').addEventListener('click', async event => {
  const status = $('[data-record-status]');
  if (recorder?.state === 'recording') { recorder.stop(); event.currentTarget.innerHTML = '<span>●</span> Record your voice'; status.textContent = 'Preparing your recording…'; return; }
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true }); chunks = [];
    recorder = new MediaRecorder(stream); recorder.ondataavailable = e => chunks.push(e.data);
    recorder.onstop = () => { stream.getTracks().forEach(track => track.stop()); loadMedia(new File(chunks, 'my-voice.webm', { type: recorder.mimeType })); status.textContent = 'Recording ready'; };
    recorder.start(); event.currentTarget.innerHTML = '<span>■</span> Stop recording'; status.textContent = 'Recording now — say your message';
  } catch (_) { status.textContent = 'Allow microphone access in your browser to record.'; }
});

$('[data-sample-design]')?.addEventListener('click', () => {
  const orderError = $('[data-order-error]');
  orderError.hidden = true;
  orderError.textContent = '';
  sampleMode = true;
  uploadedFile = null;
  memoryId = null;
  memoryReady = false;
  waveform = Array.from({ length: 120 }, (_, i) => .08 + Math.abs(Math.sin(i * .23) * Math.cos(i * .071)) * .76);
  $('[data-file-name]').textContent = 'Sample soundwave · exploration mode';
  $('[data-preview-help]').textContent = 'Explore every style now. Add your own recording before ordering.';
  unlockSteps();
  syncPreview();
  setStep(2);
});

$$('[data-next]').forEach(button => button.addEventListener('click', () => setStep(Number(button.dataset.next))));
$$('[data-back]').forEach(button => button.addEventListener('click', () => setStep(Number(button.dataset.back))));
$$('[data-step-nav]').forEach(button => button.addEventListener('click', () => !button.disabled && setStep(Number(button.dataset.stepNav))));
$$('[data-message-example]').forEach(button => button.addEventListener('click', () => { $('[data-title]').value = button.dataset.messageExample; syncPreview(); }));
$$('[data-palette]').forEach(button => button.addEventListener('click', () => {
  $('[data-bg]').value = button.dataset.background;
  $('[data-color]').value = button.dataset.wave;
  $$('[data-palette]').forEach(node => node.classList.toggle('active', node === button));
  syncPreview();
}));

function syncProductControls() {
  const product = productionProducts[$('input[name="product"]:checked')?.value] || productionProducts.canvas;
  $('[data-orientation]').innerHTML = `<option value="${product.orientation}">${product.orientation[0].toUpperCase()}${product.orientation.slice(1)}</option>`;
  $('[data-size]').innerHTML = `<option value="${product.size}">${product.size}</option>`;
  $('[data-frame]').innerHTML = `<option value="${product.frame}">${frameOptionNames[product.frame]}</option>`;
  $('[data-mat]').innerHTML = '<option value="none">No border</option>';
  syncPreview();
}
$$('input[name="product"]').forEach(node => node.addEventListener('change', syncProductControls));
$$('[data-title],[data-kicker],[data-date],[data-color],[data-bg],[data-font-style]').forEach(node => node.addEventListener('input', schedulePreview));

$$('[data-view]').forEach(button => button.addEventListener('click', async () => {
  const view = button.dataset.view; $$('[data-view]').forEach(node => {
    const active = node === button;
    node.classList.toggle('active', active);
    node.setAttribute('aria-selected', String(active));
    node.tabIndex = active ? 0 : -1;
  });
  $('[data-product-mockup]').hidden = view !== 'product'; $('[data-art-preview]').hidden = view !== 'art'; $('[data-edge-preview]').hidden = view !== 'edge'; $('[data-room-preview]').hidden = view !== 'room'; $('[data-product-3d]').hidden = view !== '3d';
  if (view === 'room') {
    const room = $('[data-room-preview]');
    if (!room.style.backgroundImage) room.style.backgroundImage = `url("${room.dataset.roomBackground}")`;
  }
  if (view === '3d' && !product3D) { try { const module = await import(window.VM_PRODUCT_3D_URL); product3D = await module.createProductViewer($('[data-product-3d]'), state()); $('[data-three-loading]')?.remove(); product3D.update(state(), renderArtwork()); } catch (_) { $('[data-three-loading]').textContent = '3D preview is temporarily unavailable.'; } }
}));

$('.vm-preview-tabs')?.addEventListener('keydown', event => {
  if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
  const tabs = $$('[data-view]');
  const current = tabs.indexOf(document.activeElement);
  if (current < 0) return;
  event.preventDefault();
  const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
  tabs[next].focus();
  tabs[next].click();
});

wallInput?.addEventListener('change', event => {
  const file = event.target.files?.[0];
  if (!file) return;
  if (!/^image\/(jpeg|png|webp)$/i.test(file.type)) {
    $('[data-wall-status]').textContent = 'Choose a JPG, PNG, or WebP wall photo.';
    return;
  }
  if (wallPhotoUrl) URL.revokeObjectURL(wallPhotoUrl);
  wallPhotoUrl = URL.createObjectURL(file);
  const room = $('[data-room-preview]');
  room.style.backgroundImage = `url("${wallPhotoUrl}")`;
  $('[data-wall-status]').textContent = `${file.name} · private preview ready`;
  $('[data-wall-reset]').hidden = false;
  $('[data-view="room"]').click();
});

$('[data-wall-reset]')?.addEventListener('click', event => {
  const room = $('[data-room-preview]');
  if (wallPhotoUrl) URL.revokeObjectURL(wallPhotoUrl);
  wallPhotoUrl = null;
  wallInput.value = '';
  room.style.backgroundImage = `url("${room.dataset.roomBackground}")`;
  $('[data-wall-status]').textContent = 'Styled room restored. Your photo was removed from this browser.';
  event.currentTarget.hidden = true;
});

$('[data-add-cart]').addEventListener('click', async () => {
  const validation = $('[data-validation]'); validation.textContent = '';
  if (!uploadedFile) {
    const message = sampleMode ? 'This is a sample preview. Add your own recording before ordering.' : 'Please add your recording first.';
    setStep(1);
    const orderError = $('[data-order-error]');
    orderError.textContent = message;
    orderError.hidden = false;
    orderError.focus({ preventScroll: false });
    return;
  }
  if (!secureUploadEnabled || !memoryId) { validation.textContent = 'Secure production upload is not available yet. Your order has not been charged or added to cart.'; return; }
  const s = state();
  const variantId = Number((catalogVariants[`${s.product}|${s.size}|${frameOptionNames[s.frame]}`] || catalogVariants[`${s.size}|${frameOptionNames[s.frame]}`])?.id || (s.product === 'canvas' ? root.dataset.canvasVariant : 0));
  if (!variantId) { validation.textContent = 'This production-verified format is not connected to a Shopify variant yet.'; return; }
  try {
    const designResponse = await fetch('/apps/voicewave/design', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ memoryId, design: { ...s, waveform: s.waveform.map(value => Number(value.toFixed(4))) } })
    });
    const designPayload = await designResponse.json();
    if (!designResponse.ok || designPayload.status !== 'ready') throw new Error(designPayload.error || 'Your design could not be secured.');
    memoryReady = true;
  } catch (error) {
    validation.textContent = error.message || 'Your design could not be secured. Please try again.';
    return;
  }
  if (!memoryReady) return;
  const properties = { 'Memory ID': memoryId, Message: s.title, Heading: s.kicker, 'Date or place': s.date, Size: s.size, Orientation: s.orientation, Frame: s.frame, Border: s.mat, 'Wave color': s.waveColor, Background: s.background, 'Message style': s.fontStyle };
  try {
    const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties }] }) });
    if (!response.ok) {
      const details = await response.json().catch(() => ({}));
      throw new Error(details.description || details.message || 'Cart request failed');
    }
    location.href = '/cart';
  } catch (error) { validation.textContent = error.message || 'We could not add this item. Please try again.'; }
});

syncProductControls(); syncPreview(); setStep(1);
